export default "__VITE_ASSET__5c4de219__"